module.exports = __webpack_public_path__ + "img/menu_realtime.ea37ba12.png";